export class CaseDocument{
id:number;
caseId:number;
documentName:string;
 documentUrl:string;
 documentContentType:string;
 authorUserId:number;
 userName:string
 creationDate:Date 
 editedByUserId:number|null;
 lastRevisedDate:Date|null;
}